import { render, staticRenderFns } from "./StarRatingConfigForm.vue?vue&type=template&id=38e44fcb&scoped=true&"
import script from "./StarRatingConfigForm.vue?vue&type=script&lang=js&"
export * from "./StarRatingConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./StarRatingConfigForm.vue?vue&type=style&index=0&id=38e44fcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e44fcb",
  null
  
)

export default component.exports